'use strict';

var React = require('react');

var SvgFileFilledIcon = function SvgFileFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.25 3h-3a1.75 1.75 0 0 0-1.75 1.75v10.5c0 .966.784 1.75 1.75 1.75h7.5a1.75 1.75 0 0 0 1.75-1.75v-6.045h-4.62a1.625 1.625 0 0 1-1.626-1.624l-.003-4.581Zm-2.225 11c0-.483.392-.875.875-.875h4.2a.875.875 0 0 1 0 1.75h-4.2a.875.875 0 0 1-.875-.875Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.214 7.955h-4.335a.375.375 0 0 1-.375-.375l-.003-4.322c.116.072.224.157.322.255l4.164 4.164c.086.085.162.178.227.278Z"
  }));
};
SvgFileFilledIcon.displayName = "FileFilledIcon";

exports.SvgFileFilledIcon = SvgFileFilledIcon;
